/**
 * Routes listed here own their own full-page layout instead of using BaseView.
 *
 * @param routeName - Vue Router route name to inspect.
 * @returns Whether the brand route should bypass the default BaseView wrapper.
 */
export function isWrapperlessBrandRouteName(routeName: unknown): boolean {
  if (typeof routeName !== 'string') {
    return false
  }

  return (
    routeName.startsWith('brand.setup') ||
    routeName.startsWith('location.setup') ||
    routeName.startsWith('brand.onboarding.subscribe') ||
    routeName === 'brand.apps.customers' ||
    routeName === 'brand.inbox' ||
    routeName === 'brand.tools.phone-ordering' ||
    routeName === 'brand.tools.acceptance-document'
  )
}
